function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyToClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "%23fff",
    fillRule: "evenodd",
    d: "M33.634 24.793v-5.09l-7.34 7.634 7.34 7.633v-5.089h12.233v-5.088Z",
    style: {
      strokeWidth: 2.49503
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.59844 0 0 1.59844 -1.252 1.667)",
    style: {
      strokeWidth: 0.99972261,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.99972261,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    cx: 15,
    cy: 3,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.99972261,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    d: "M24 21.822V24a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5M17 4h5a2 2 0 0 1 2 2v4.947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5.789h-4c-.552 0-1-.267-1-.597V4h6v1.192c0 .33-.448.597-1 .597z",
    style: {
      strokeWidth: 0.771955,
      strokeDasharray: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.99972261,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    d: "M14.754 16h-5M17.754 12h-8M17.754 20h-8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copyToClipboard.44ec9779f83b46ee8f5c360dc2974045.svg";
export { ForwardRef as ReactComponent };